import { render, staticRenderFns } from "./OpenInTeams.vue?vue&type=template&id=6fde6656&scoped=true"
import script from "./OpenInTeams.vue?vue&type=script&lang=js"
export * from "./OpenInTeams.vue?vue&type=script&lang=js"
import style0 from "./OpenInTeams.vue?vue&type=style&index=0&id=6fde6656&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fde6656",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fde6656')) {
      api.createRecord('6fde6656', component.options)
    } else {
      api.reload('6fde6656', component.options)
    }
    module.hot.accept("./OpenInTeams.vue?vue&type=template&id=6fde6656&scoped=true", function () {
      api.rerender('6fde6656', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/clients/components/OpenInTeams.vue"
export default component.exports